module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA5ElEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GICoYDKZwW4xlckEVQNQHRTJycHZQOmJy9qPn/fcsdPp5AXXScvaEBogjkY4acWK3v69QOnXn3W+/uBatVLl9h3Otx9kkGyYPt2vcAdcQ3XXfoinp89oXrh98/z9h5YeOzbj4C2EBiALK2pNdysrMmtbebakY2HTxL0ENDCbzAjOnRMUa6SQVSUfFuSXu5SwDYwmM32Kt5h2L/es3g5ko2ogjMjTMCgBADPayi9m0sppAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SH.png
// module id = 1261
// module chunks = 0